(() => {
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
  const prefetched = new Set();
  let hoverTimer;

  const eligibleUrl = (target) => {
    const link = target instanceof Element ? target.closest('a[href]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-no-prefetch')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.username || url.password || url.hash) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    // Only storefront documents. Never warm cart, checkout, account, or app actions.
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:$|products\/[^/]+\/?$|collections(?:\/[^/]+)?\/?$|pages\/[^/]+\/?$|blogs\/[^/]+(?:\/[^/]+)?\/?$)/i.test(url.pathname)) return;
    if ([...url.searchParams.keys()].some((key) => !['variant', 'page', 'sort_by'].includes(key))) return;
    return url.href;
  };

  const prefetch = (target) => {
    if (document.readyState === 'loading' || document.hidden || prefetched.size >= 4) return;
    const url = eligibleUrl(target);
    if (!url || prefetched.has(url)) return;
    prefetched.add(url);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = url;
    hint.fetchPriority = 'low';
    document.head.appendChild(hint);
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => prefetch(event.target), 80);
  }, { passive: true });
  document.addEventListener('pointerout', () => clearTimeout(hoverTimer), { passive: true });
  document.addEventListener('focusin', (event) => prefetch(event.target));
  document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    prefetch(event.target);
  }, { passive: true });
})();
